export default function MenuItem(theme: any) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: theme.palette.label.main,
            '&:hover': {
              backgroundColor: theme.palette.label.main,
            },
          },
          '&:hover': {
            backgroundColor: theme.palette.label.main,
          },
        },
      },
    },
  }
}
